// removed by extract-text-webpack-plugin
module.exports = {"left-panel":"styles-module__left-panel___1Sqgj","left-panel-header":"styles-module__left-panel-header___l5hYP","left-panel-body":"styles-module__left-panel-body___2PICM","left-panel-footer":"styles-module__left-panel-footer___QIJ1t","left-panel-footer-btn-group":"styles-module__left-panel-footer-btn-group___yArLY","more-button":"styles-module__more-button___3OIEw","settings":"styles-module__settings___20Qlz"};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/GenericLeftPanel/styles.module.css
// module id = 411
// module chunks = 0